<template>
  <div class="mx-4 mt-3 billing-container">
    <div
      class="d-flex flex-row justify-content-between align-items-center mb-3"
    >
      <div
        class="d-flex flex-row justify-content-start align-items-center"
        style="width: 220px"
      >
        <div
          class="
            main-image-container
            bg-purple
            rounded
            d-flex
            justify-content-center
            align-items-center
          "
        >
          <img
            height="25"
            width="25"
            :src="require('../../assets/icons/invoice.svg')"
          />
        </div>
        <h3 class="mb-0 ml-3">Billing</h3>
      </div>
      <view-switch :options="getViewOptions" v-model="currentView" />
      <div class="d-flex justify-content-end" style="width:350px;">
        <b-button
          variant="primary"
          v-if="isCollaborateMDActive && currentView === 'encounters'"
          @click="openCollaborateMD"
          class="smaller-button button-primary-shadow mr-2"
        >
          Open Collaborate MD
        </b-button>
        <b-button
          variant="primary"
          v-if="
            isPracticeSuiteActive &&
              currentUser &&
              currentUser.practiceSuiteUserId &&
              currentView === 'encounters'
          "
          @click="openPracticeSuite"
          class="smaller-button button-primary-shadow"
        >
          Open Practice Suite
        </b-button>
        <b-button
          v-if="currentView === 'billing_docs'"
          variant="primary"
          class="smaller-button button-primary-shadow mr-2"
          @click="openNewInvoiceModal"
        >
          <span class="px-3">
            <span class="fa fa-plus" /> &nbsp;&nbsp;New Invoice</span
          >
        </b-button>
        <b-button
          v-if="currentView === 'billing_docs'"
          variant="primary"
          class="smaller-button button-primary-shadow mr-2"
          @click="openNewStatementModal"
        >
          <span class="px-3">
            <span class="fa fa-plus" /> &nbsp;&nbsp;New Statement</span
          >
        </b-button>
        <practice-suite />
      </div>
    </div>

    <encounter
      v-show="showing && currentView === 'encounters'"
      :showing="showing && currentView === 'encounters'"
    />

    <billing-document
      v-show="showing && currentView === 'billing_docs'"
      :showing="showing && currentView === 'billing_docs'"
      :invoiceModalShow="newInvoiceModal"
      :statementModalShow="newStatementModal"
      @changeModalShow="changNewInvoceModalState"
      @changeStatementModalShow="changNewStatementModalState"
    />

    <billing-transactions
      :showing="showing && currentView == 'transactions'"
      v-show="showing && currentView == 'transactions'"
    />
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import PracticeSuite from "../practice_suite/PracticeSuiteIndex.vue";
import practiceSuiteServer from "../../server/practiceSuite";
import ViewSwitch from "../controls/ViewSwitch.vue";
import Encounter from "./encounter/EncounterIndex";
import BillingDocument from "./billing_document/BillingDocumentIndex.vue";
import BillingTransactions from "./billing_transactions/BillingTransactionsIndex.vue";

export default {
  name: "Billing",
  components: {
    PracticeSuite,
    ViewSwitch,
    BillingDocument,
    BillingTransactions,
    Encounter
  },
  props: ["showing"],
  data() {
    return {
      currentView: "encounters",
      viewOptions: [
        {
          value: "encounters",
          label: "Encounters",
          icon: "fa fa-calendar",
          width: "110"
        },
        {
          value: "billing_docs",
          label: "Billing Documents",
          icon: "fa fa-file-invoice",
          width: "150"
        },
        {
          value: "transactions",
          label: "Transactions",
          icon: "fa fa-file-invoice-dollar",
          width: "130"
        }
      ],
      refetchBillings: true,
      newInvoiceModal: false,
      newStatementModal: false
    };
  },
  methods: {
    ...mapActions("layout", [
      "showAlertSuccess",
      "showError",
      "show",
      "hide",
      "toggleAssignToMeBillingIndex"
    ]),
    async openPracticeSuite() {
      const urlDataResult = await practiceSuiteServer.getUrlData();
      const token = urlDataResult.accessToken;
      var xhr = new XMLHttpRequest();

      xhr.open("GET", urlDataResult.clientUrl);
      xhr.onreadystatechange = handler;
      xhr.responseType = "blob";
      xhr.setRequestHeader("Authorization", "Bearer " + token);
      xhr.send();

      function handler() {
        if (this.readyState === this.DONE) {
          if (this.status === 200) {
            // this.response is a Blob, because we set responseType above
            const url = URL.createObjectURL(this.response);
            window.open(url, "_blank").focus();
          } else {
            console.error("error");
          }
        }
      }
    },
    async openCollaborateMD() {
      const url = "https://app.collaboratemd.com/";
      window.open(url, "_blank").focus();
    },
    openNewInvoiceModal() {
      this.newInvoiceModal = true;
    },
    openNewStatementModal() {
      this.newStatementModal = true;
    },
    changNewInvoceModalState() {
      this.newInvoiceModal = false;
    },
    changNewStatementModalState() {
      this.newStatementModal = false;
    }
  },
  computed: {
    ...mapState("layout", {
      isPracticeSuiteActive: state => state.isPracticeSuiteActive,
      isCollaborateMDActive: state => state.isCollaborateMDActive,
      currentUser: state => state.currentUser,
      systemSetting: state => state.systemSetting,
      assignedToMe: state => state.assignedToMeBillingIndex
    }),
    getViewOptions() {
      if (this.showing) {
        return this.viewOptions.filter(option => {
          if (!this.systemSetting.enablePaymentSystem) {
            if (
              option.value === "transactions" ||
              option.value === "billing_docs"
            )
              return false;
          }
          return true;
        });
      }
      return []
    }
  }
};
</script>
